import { isPastDue } from "utils/paymentDueDate";
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { savePdfResponse } from "utils/documentPdf";
import {
  Box,
  Button,
  Card,
  CardContent,
  FormControl,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import axios from "axios";
import { getColorMappings } from "components/ColorComponent/ColorComponent";
import TimelineItem from "components/Icon/TimelineItem";
import LoadingModal from "components/LoadingModel/loadingModal";
import PageSkeleton from "components/Skeleton/PageSkeleton";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { useMaterialUIController } from "context";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import PageTitle from "examples/PageTitle/PageTitle";
import ActivityLog from "layouts/activityLog/activityLog";
import { useCallback, useEffect, useMemo, useState } from "react";
import DataTable, { createTheme } from "react-data-table-component";
import { Link, useNavigate, useParams } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { appConstants } from "utils/appConstants";
import DownloadIcon from "@mui/icons-material/Download";
import { fetchInvoicePdfTheme } from "utils/api";
import { generateDataList } from "utils/generic";
import { showResMsg } from "utils/generic";
import { useDispatch } from "react-redux";
import InvoiceModal from "components/invoiceModal/invoiceModal";
import ShowSwalWithButtons from "components/SwalAlert/swalPopupWithButtons";
import { downloadInvoice } from "utils/api";
import { AllKeysHaveValue } from "utils/generic";
import { getEmailAndTemplateForQuotation } from "utils/quotationAPI";
import EmailTemplateModal from "components/EmailModal/EmailTemplateModal";
import SendInvoiceModal from "./SendInvoiceModal";
import InvoiceAttachmentPreview from "./InvoiceAttachmentPreview";
import RecordInvoicePaymentDialog from "./RecordInvoicePaymentDialog";
import { ResendEmail } from "utils/invoiceAPI";
import { fetchActivityLog, saveNotes } from "utils/api";
import {
  includeLegacyInvoiceDelivery,
  isInternalNoteActivity,
} from "utils/invoiceHistory";
import { formatActivityTimestamp } from "utils/activityTimestamp";
import AppHeader from "components/AppHeader";
import { DashboardNavigation } from "layouts/businessUserDashboard";
import DebitNoteResponsiveHeader from "layouts/DebitNote/DebitNoteResponsiveHeader";
import {
  LuArrowLeft,
  LuDownload,
  LuEye,
  LuFileText,
  LuHistory,
  LuLock,
  LuPencil,
  LuSend,
} from "react-icons/lu";
import "./invoiceFlow.css";
import "layouts/Quotation/quotation.css";
const pdfStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  height: "90%x",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const toCurrencyCode = (currency) => {
  const value = String(currency || "AUD")
    .trim()
    .toUpperCase();
  if (/^[A-Z]{3}$/.test(value)) return value;
  const symbolCodes = {
    $: "AUD",
    A$: "AUD",
    AU$: "AUD",
    US$: "USD",
    "€": "EUR",
    "£": "GBP",
    "¥": "JPY",
  };
  if (symbolCodes[value]) return symbolCodes[value];
  const code = value.match(/\b[A-Z]{3}\b/);
  return code ? code[0] : "AUD";
};

createTheme(
  "solarized",
  {
    text: {
      primary: "white",
      secondary: "white",
    },
    background: {
      default: "var(--surface-primary, #191b1f)",
    },
    context: {
      background: "var(--surface-primary, #191b1f)",
      text: "white",
    },
    divider: {
      default: "white",
    },
    sortFocus: {
      default: "#2aa198",
    },
  },
  "dark"
);
createTheme(
  "light",
  {
    text: {
      primary: "black",
      secondary: "black",
    },
    background: {
      default: "white",
    },
    context: {
      background: "white",
      text: "black",
    },
    divider: {
      default: "gray",
    },
    sortFocus: {
      default: "#2aa198",
    },
  },
  "dark"
);

function ViewInvoices() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let changePaginationText =
    document.getElementsByClassName("rdt_Pagination")[0];
  if (changePaginationText !== undefined) {
    changePaginationText.getElementsByTagName("span")[0].textContent =
      "Records Per Page";
  }

  const { id: InvoiceID } = useParams();
  const [viewDocumentInModal, setViewDocumentInModal] = useState(false);
  const [previewAttachment, setPreviewAttachment] = useState(null);
  const [paymentDialogOpen, setPaymentDialogOpen] = useState(false);
  const [controller] = useMaterialUIController();
  const { darkMode, sidenavColor } = controller;
  const { barColor, tableBorder } = getColorMappings(sidenavColor);
  const [loading, setLoading] = useState(false);
  const [navOpen, setNavOpen] = useState(false);
  const [paymentHistory, setPaymentHistory] = useState([]);
  const [activityRows, setActivityRows] = useState([]);
  const [internalNote, setInternalNote] = useState("");
  const [savingNote, setSavingNote] = useState(false);
  const [retentionItemValues, setRetentionItemValues] = useState([]);
  const [showInvoiceSection, setShowInvoiceSection] = useState(false);
  const [itemRowValues, setItemRowValues] = useState([
    {
      itemName: "",
      itemPrice: "",
      itemQuantity: "",
      categoryCodeName: "",
      gst: "",
      priceValidity: "None",
      priceValidityValue: "",
      discountType: "None",
      discountValue: "",
      discountAmount: "",
    },
  ]);
  const [displayDialogeFlag, setDisplayDialogeFlag] = useState(false);
  const [themeName, setThemeName] = useState([]);
  const [themeValues, setThemeValues] = useState({
    _id: InvoiceID,
    themeID: "",
  });
  const [open, setOpen] = useState(false);
  const [emailMode, setEmailMode] = useState("resend");
  const [templateValues, setTemplateValues] = useState({
    screenType: "Invoices",
    userEmailAddress: "",
    customerEmailAddress: [],
    emailTemplate: "",
  });
  const [loginDetails, setLoginDetails] = useState(
    JSON.parse(sessionStorage.getItem("LOGIN_DETAILS"))
  );
  const [getDocumentFileURL, setSetDocumentFileURL] = useState("");
  const [currencyCode, setCurrencyCode] = useState("");
  const [values, setValues] = useState({
    quotationID: undefined,
    invoiceID: "",
    invoiceNumber: "Auto Generated",
    contactID: "",
    purchaseOrderNumber: "",
    invoiceDate: new Date(),
    validUpto: "Same Day",
    validUptoDate: new Date(),
    invoiceStatus: "Unpaid",
    gstType: "Inclusive",
    totalAmount: 0,
    totalDiscountAmount: 0,
    finalAmount: 0,
    paymentInstruction: "",
    sendEmailFlag: false,
  });
  const [quoDocuments, setDocuments] = useState([]);
  const currentUser =
    `${loginDetails?.firstName || ""} ${loginDetails?.lastName || ""}`.trim() ||
    "User";
  const detailedActivityRows = useMemo(
    () => includeLegacyInvoiceDelivery(activityRows, values, currentUser),
    [activityRows, currentUser, values]
  );

  console.log(InvoiceID);
  useEffect(() => {
    const fetchData = async () => {
      setLoginDetails(JSON.parse(sessionStorage.getItem("LOGIN_DETAILS")));
      await FetchPendingInvoiceForCustomer();
    };
    fetchData();
  }, []);

  const loadInvoiceActivity = useCallback(() => {
    if (!InvoiceID || !loginDetails?.businessUserID) return;
    fetchActivityLog(
      {
        _id: InvoiceID,
        businessUserID: loginDetails.businessUserID,
        userID: loginDetails._id,
        details: "",
        sortingType: -1,
        sortingField: "dateAndTime",
        screenType: "Invoices",
        invoiceStatus: "All",
        page: 1,
        limit: 10,
        filterValues: "",
        searchParameterList: ["dateAndTime", "name", "action", "details"],
        token: loginDetails.token,
      },
      (data) => setActivityRows(data?.Result_Output?.docs || []),
      dispatch
    );
  }, [InvoiceID, dispatch, loginDetails]);

  useEffect(() => {
    loadInvoiceActivity();
  }, [loadInvoiceActivity]);

  const handleEmailQuotation = async (requestedMode = "resend") => {
    setEmailMode(typeof requestedMode === "string" ? requestedMode : "resend");
    if (AllKeysHaveValue(templateValues)) {
      setOpen(true);
    } else {
      await getEmailAndTemplateForQuotation(
        {
          screenType: templateValues.screenType,
          contactID: values.contactID,
          selectedID: InvoiceID,
          userID: sessionStorage.getItem("USER_ID").replaceAll('"', ""),
        },
        (data) => {
          console.log("data", data);
          if (data.Result_Status) {
            console.log("email", data.Result_Status);
            setTemplateValues(data.Result_Output);
            setOpen(true);
          } else {
            showResMsg(data.Result_Message, 2000, false);
            setOpen(false);
          }
        },
        dispatch
      );
    }
  };

  // const handleResendEmail = async (selectedRow) => {
  //   if (AllKeysHaveValue(templateValues)) {
  //     setOpen(true);
  //   } else {
  //     await getEmailAndTemplateForQuotation({ screenType: templateValues.screenType, contactID: selectedRow.contactID, selectedID: selectedRow._id, userID: sessionStorage.getItem("USER_ID").replaceAll('"', "") }, (data) => {
  //       if (data.Result_Status) {
  //         setTemplateValues(data.Result_Output);
  //         setOpen(true);
  //       } else {
  //         showResMsg(data.Result_Message, 2000, false);
  //         setOpen(false);
  //       }
  //     }, dispatch);
  //   }
  // }

  const handleClose = (event, reason) => {
    if (reason && reason === "backdropClick") return;
    setOpen(false);
  };
  const handleSend = async (templateData) => {
    return new Promise((resolve) => {
      let payload = {
        selectedID: templateData.selectedID || InvoiceID,
        userEmailAddress: templateData.userEmailAddress,
        customerEmailAddress: [...templateData.customerEmailAddress],
        emailTemplate: { ...templateData.emailTemplate },
        sendMeCopy: templateData.sendMeCopy,
        businessUserID: loginDetails?.businessUserID,
        emailMode,
      };
      ResendEmail(
        payload,
        (data) => {
          let status = data?.Result_Status;
          if (status) {
            showResMsg(
              data?.Result_Message || "Invoice sent successfully.",
              2000,
              true
            );
            FetchPendingInvoiceForCustomer();
            loadInvoiceActivity();
            resolve({ success: true, message: data?.Result_Message });
          } else {
            resolve({
              success: false,
              message:
                data?.Result_Message ||
                "Failed to send invoice email. Please check the recipient address or try again.",
            });
          }
        },
        dispatch
      );
      values.sendEmailFlag = true;
      values.templateValues = payload;
    });
  };

  const FetchPendingInvoiceForCustomer = async () => {
    setLoading(true);
    try {
      const res = await axios.post(
        appConstants.baseURL + "invoice/viewInvoiceByID",
        { invoiceID: InvoiceID }
      );
      const result = res.data?.Result_Output;
      const invoice = Array.isArray(result) ? result[0] : result;

      if (!invoice || !res.data?.Result_Status) {
        setShowInvoiceSection(false);
        showResMsg(
          res.data?.Result_Message || "Unable to load this invoice.",
          2000,
          false
        );
        return;
      }

      setShowInvoiceSection(true);
      setValues(invoice);
      setCurrencyCode(toCurrencyCode(invoice.currencyValue));
      setItemRowValues(invoice.itemsList?.length ? invoice.itemsList : []);
      setDocuments(invoice.documentsList?.length ? invoice.documentsList : []);
      setPaymentHistory(
        invoice.invoicePayment?.length ? invoice.invoicePayment : []
      );
      setRetentionItemValues(
        invoice.retentions?.length ? invoice.retentions : []
      );
    } catch (error) {
      console.error("Error in fetchPendinginvoiceForCustomer: ", error);
      setShowInvoiceSection(false);
      showResMsg("Unable to load this invoice.", 2000, false);
    } finally {
      setLoading(false);
    }
  };

  const customStyles = {
    table: {
      style: {
        borderColor: tableBorder,
      },
    },
    headRow: {
      style: {
        color: darkMode ? "white" : "white",
        background: barColor,
        minHeight: "30px",
      },
    },
    headCells: {
      style: {
        paddingLeft: "5px",
        paddingRight: "5px",
        fontSize: "12px",
        color: "white",
      },
    },
  };
  let columns = [
    {
      name: "Item Name",
      selector: (row) => row.itemName,
      sortable: true,
      center: "true",
      style: { paddingLeft: "10px" },
    },
    {
      name: "Description",
      selector: (row) => row.itemDescription,
      sortable: true,
      center: "true",
      style: { paddingLeft: "10px", textAlign: "center" },
    },
    {
      name: "Qty",
      selector: (row) => row.itemQuantity,
      sortable: true,
      center: "true",
      style: { paddingLeft: "10px" },
    },
    {
      name: `Item Price (${currencyCode})`,
      selector: (row) => row.itemPrice,
      sortable: true,
      center: "true",
      style: { paddingLeft: "10px" },
    },
    {
      name: "Account",
      selector: (row) => row.categoryCodeName,
      sortable: true,
      center: "true",
      style: { paddingLeft: "10px", textAlign: "center" },
    },
    {
      name: "GST(%)",
      selector: (row) => row.gst,
      sortable: true,
      center: "true",
      style: { paddingLeft: "10px" },
    },
    // {
    //   name: "Discount Type",
    //   selector: row => row.discountType,
    //   sortable: true,
    //   center: "true",
    //   style: { paddingLeft: "10px" },
    // },
    // {
    //   name: "Discount Value",
    //   selector: row => row.discountValue,
    //   sortable: true,
    //   center: "true",
    //   style: { paddingLeft: "10px" },
    // },
  ];
  // let columns = [
  //   {
  //     name: "Item Name",
  //     selector: (row, i) => (
  //       <TextField
  //         type="text"
  //         value={row.itemName}
  //         variant="outlined"
  //         disabled
  //         fullWidth
  //       />

  //     ),
  //     style: {
  //       paddingLeft: "10px",
  //       paddingTop: "10px",
  //       paddingRight: "10px",
  //       paddingBottom: "10px",
  //       display: "block"
  //     },
  //   },
  //   {
  //     name: "Item Price",
  //     selector: (row, i) => (
  //       <TextField
  //         type="text"
  //         value={row.itemPrice}
  //         variant="outlined"
  //         disabled
  //         fullWidth

  //       />
  //     ),
  //     center: true,
  //     style: {
  //       paddingLeft: "10px",
  //       paddingTop: "10px",
  //       paddingRight: "10px",
  //       paddingBottom: "10px",
  //     },
  //   },
  //   {
  //     name: "Item Quantity",
  //     selector: (row, i) => (
  //       <TextField
  //         type="text"
  //         autoComplete="off"
  //         value={row.itemQuantity}
  //         variant="outlined"
  //         disabled
  //         fullWidth

  //       />
  //     ),
  //     center: true,
  //     style: {
  //       paddingLeft: "10px",
  //       paddingTop: "10px",
  //       paddingRight: "10px",
  //       paddingBottom: "10px",
  //     },
  //   },
  //   {
  //     name: "GST%",
  //     selector: (row, i) => (
  //       <TextField
  //         type="text"
  //         autoComplete="off"
  //         variant="outlined"
  //         fullWidth
  //         value={row.gst}
  //         disabled
  //         style={{ cursor: 'default', pointerEvents: 'none' }}

  //       />
  //     ),
  //     center: true,
  //     style: {
  //       paddingLeft: "10px",
  //       paddingTop: "10px",
  //       paddingRight: "10px",
  //       paddingBottom: "10px",
  //     },
  //   },
  //   {
  //     name: "Discount Type",
  //     selector: (row, i) => (
  //       <Select
  //         style={{ height: "35.25px" }}
  //         labelId="day-hours-select-label"
  //         id="day-hours-select"
  //         value={row.discountType}
  //         disabled
  //         fullWidth
  //         variant="outlined"
  //       >
  //         <MenuItem value="None">None</MenuItem>
  //         <MenuItem value="Percentage">Percentage %</MenuItem>
  //         <MenuItem value="Fixed">Fixed</MenuItem>
  //       </Select>
  //     ),
  //     center: true,
  //     style: {
  //       paddingLeft: "10px",
  //       paddingTop: "10px",
  //       paddingRight: "10px",
  //       paddingBottom: "10px", display: "block"
  //     },
  //   },
  //   {
  //     name: "Discount Value",
  //     selector: (row, i) => (
  //       <TextField
  //         type="text"
  //         autoComplete="off"
  //         variant="outlined"
  //         fullWidth
  //         value={row.discountType === "None" ? 0 : row.discountValue}
  //         disabled

  //       />
  //     ),
  //     center: true,
  //     style: {
  //       paddingLeft: "10px",
  //       paddingTop: "10px",
  //       paddingRight: "10px",
  //       paddingBottom: "10px",
  //     },
  //   },
  //   {
  //     name: "Discount Amount($)",
  //     selector: (row, i) => (
  //       <TextField
  //         type="text"
  //         autoComplete="off"
  //         variant="outlined"
  //         fullWidth
  //         value={row.discountType === "None" ? 0 : row.discountAmount}
  //         disabled

  //       />
  //     ),
  //     center: true,
  //     style: {
  //       paddingLeft: "10px",
  //       paddingTop: "10px",
  //       paddingRight: "10px",
  //       paddingBottom: "10px",
  //     },
  //   },

  // ];

  const handleViewDocument = (selectedDocRow) => {
    setSetDocumentFileURL(
      appConstants.baseURL +
        "quotation/viewUploadedQuotationDocument?fileName=/" +
        selectedDocRow.documentFileName
    );
    setViewDocumentInModal(true);
  };

  const documentColumns = [
    {
      name: "Document Name",
      selector: (row) => row.documentName,
      sortable: true,
      sortField: "name",
      style: { paddingLeft: "10px" },
    },
    {
      name: "Action",
      selector: (row) => row,
      center: true,
      cell: (row) => (
        <>
          <Grid item mt={-3}>
            <TimelineItem
              color="info"
              icon="visibility"
              onClick={() => {
                handleViewDocument(row);
              }}
              title="View"
            />
          </Grid>
        </>
      ),
    },
  ];

  const paginationComponentOptions = {
    selectAllRowsItem: false,
  };

  const paymentColumns = [
    {
      name: "Payment Date",
      selector: (row) => row.paymentDate,
      sortable: true,
      sortField: "paymentDate",
      style: { paddingLeft: "10px" },
    },
    {
      name: "Payment Mode",
      selector: (row) => row.paymentMode,
      sortable: true,
      sortField: "partialPayment",
      style: { paddingLeft: "10px" },
    },
    {
      name: "Transaction ID",
      selector: (row) => row.paymentTransactionID,
      sortable: true,
      sortField: "paymentTransactionID",
      style: { paddingLeft: "10px" },
    },
    {
      name: "Payment Type",
      selector: (row) => row.paymentType,
      sortable: true,
      sortField: "paymentType",
      style: { paddingLeft: "10px" },
    },
    {
      name: `Payment Amount (${currencyCode})`,
      selector: (row) => row.paymentAmount,
      sortable: true,
      center: true,
      sortField: "paymentAmount",
      style: { paddingLeft: "10px" },
    },
    {
      name: `Pending Amount (${currencyCode})`,
      selector: (row) => row.pendingAmount,
      sortable: true,
      sortField: "pendingAmount",
      center: true,
      style: { paddingLeft: "10px" },
    },
  ];
  let columnRetention = [
    {
      name: "Retention No.",
      selector: (row) => row.retentionNumber,
      sortable: true,
      center: "true",
      style: { paddingLeft: "10px" },
    },
    {
      name: `Payment Status`,
      selector: (row) => row.retentionStatus,
      sortable: true,
      center: "true",
      style: { paddingLeft: "10px" },
    },
    {
      name: `Retention Due Date`,
      selector: (row) => row.retentionDueDate,
      sortable: true,
      center: "true",
      style: { paddingLeft: "10px" },
    },
    {
      name: `Payment Amount (${currencyCode})`,
      selector: (row) => parseFloat(row.retentionPaymentAmount).toFixed(2),
      sortable: true,
      center: "true",
      style: { paddingLeft: "10px" },
    },
  ];
  const handleDirectDownload = async () => {
    try {
      await downloadInvoice(
        { _id: InvoiceID },
        (response) => {
          savePdfResponse(response, `${values.invoiceNumber || "invoice"}.pdf`);
        },
        dispatch
      );
    } catch (error) {
      console.error("Direct download failed:", error);
      showResMsg("Unable to download invoice PDF.", 2500, false);
    }
  };
  const organisation =
    loginDetails?.companyName ||
    loginDetails?.businessName ||
    loginDetails?.organisationName ||
    loginDetails?.organizationName ||
    loginDetails?.fullName ||
    loginDetails?.name ||
    "My Organisation";
  const money = (amount) =>
    new Intl.NumberFormat("en-AU", {
      style: "currency",
      currency: toCurrencyCode(currencyCode),
    }).format(Number(amount || 0));
  const displayDate = (date) =>
    date
      ? new Intl.DateTimeFormat("en-AU", {
          day: "numeric",
          month: "short",
          year: "numeric",
        }).format(new Date(date))
      : "—";
  const invoiceStatus = values.invoiceStatus || "Draft";
  const toAmount = (amount) =>
    Number(String(amount ?? 0).replace(/[^0-9.-]/g, "")) || 0;
  const totalPaid = paymentHistory.reduce(
    (sum, payment) => sum + toAmount(payment.paymentAmount || payment.amount),
    0
  );
  const invoiceTotal = toAmount(values.finalAmount ?? values.totalAmount);
  const debitTotal = (values.debitAdjustments || []).reduce((sum, note) => sum + toAmount(note.amount), 0);
  const creditTotal = (values.creditAdjustments || []).reduce((sum, note) => sum + toAmount(note.appliedToBalance ?? note.amount), 0);
  const adjustmentNotes = [
    ...(values.creditAdjustments || []).map((note) => ({
      ...note,
      type: "credit",
      amount: note.appliedToBalance ?? note.amount,
      date: note.appliedAt,
    })),
    ...(values.debitAdjustments || []).map((note) => ({
      ...note,
      type: "debit",
      date: note.issuedAt,
    })),
  ].sort(
    (left, right) =>
      new Date(right.date || 0).getTime() -
      new Date(left.date || 0).getTime()
  );
  const outstanding = Math.max(
    0,
    toAmount(values.payablePendingAmount ?? invoiceTotal - totalPaid)
  );
  const statusText = String(invoiceStatus || "").toLowerCase();
  const activityStatusText = String(values.activityStatus || "").toLowerCase();
  const isSent =
    Number(values.emailSent) > 0 ||
    /^(sent|viewed|issued)$/.test(activityStatusText);
  const isVoided = statusText.includes("void");
  const isPaid =
    !isVoided &&
    (statusText === "paid" ||
      (invoiceTotal > 0 && outstanding <= 0 && totalPaid > 0));
  const isDraft =
    !isVoided &&
    !isPaid &&
    !/partial|overdue/.test(statusText) &&
    totalPaid <= 0 &&
    !isSent;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const isOverdue =
    !isVoided &&
    !isDraft &&
    !isPaid &&
    outstanding > 0 &&
    isPastDue(values.dueDate);
  const isPartiallyPaid =
    !isVoided &&
    !isDraft &&
    !isPaid &&
    !isOverdue &&
    (statusText.includes("partial") || (totalPaid > 0 && outstanding > 0));
  const stateLabel = isVoided
    ? "Voided"
    : isPaid
    ? "Paid"
    : isOverdue
    ? "Overdue"
    : isPartiallyPaid
    ? "Partially paid"
    : isDraft
    ? "Draft"
    : "Awaiting payment";
  const saveInternalNote = () => {
    if (!internalNote.trim() || savingNote) return;
    setSavingNote(true);
    saveNotes(
      {
        _id: InvoiceID,
        businessUserID: loginDetails?.businessUserID,
        userID: loginDetails?._id,
        details: internalNote.trim(),
        screenType: "Invoices",
        token: loginDetails?.token,
      },
      (result) => {
        setSavingNote(false);
        if (result?.Result_Status) {
          setInternalNote("");
          fetchActivityLog(
            {
              _id: InvoiceID,
              businessUserID: loginDetails?.businessUserID,
              userID: loginDetails?._id,
              details: "",
              sortingType: -1,
              sortingField: "dateAndTime",
              screenType: "Invoices",
              invoiceStatus: "All",
              page: 1,
              limit: 10,
              filterValues: "",
              searchParameterList: ["dateAndTime", "name", "action", "details"],
              token: loginDetails?.token,
            },
            (data) => setActivityRows(data?.Result_Output?.docs || []),
            dispatch
          );
        }
        showResMsg(
          result?.Result_Message || "Note saved",
          1600,
          Boolean(result?.Result_Status)
        );
      },
      dispatch
    );
  };
  const goToInvoiceHistory = () =>
    navigate(`/invoices/activityLog/${InvoiceID}`);
  const goToPayment = () => setPaymentDialogOpen(true);

  const invoiceActivityFeed = (
    <div className="invoice-activity-list">
      {detailedActivityRows.length ? (
        detailedActivityRows.slice(0, 3).map((activity, index) => {
          const isNote = isInternalNoteActivity(activity);
          return (
            <article
              className={isNote ? "note" : ""}
              key={activity._id || `${activity.dateAndTime}-${index}`}
            >
              <strong>
                {isNote
                  ? "Internal note"
                  : activity.action || "Invoice updated"}
              </strong>
              <time>
                {formatActivityTimestamp(
                  activity.dateAndTime,
                  displayDate(values.createdAt || values.invoiceDate)
                )}
              </time>
              <span>
                {activity.name || activity.createdByName || currentUser}
              </span>
              <p>{activity.details || "Invoice record updated."}</p>
            </article>
          );
        })
      ) : (
        <article>
          <strong>Created invoice</strong>
          <time>{displayDate(values.createdAt || values.invoiceDate)}</time>
          <span>{currentUser}</span>
          <p>
            Created {values.invoiceNumber || "invoice"}
            {values.quotationNumber
              ? ` from approved quote ${values.quotationNumber}`
              : ""}
            .
          </p>
        </article>
      )}
    </div>
  );

  const invoiceNoteComposer = (
    <div className="invoice-note-composer">
      <label>
        Add an internal note
        <textarea
          value={internalNote}
          onChange={(event) => setInternalNote(event.target.value)}
          placeholder="Write a note for your team..."
        />
        <small>Only visible to your team</small>
      </label>
      <button
        type="button"
        onClick={saveInternalNote}
        disabled={!internalNote.trim() || savingNote}
      >
        {savingNote ? "Saving…" : "Add note"}
      </button>
    </div>
  );

  const invoiceDetailsRedesignEnabled = Boolean("invoice-flow-v2");
  if (invoiceDetailsRedesignEnabled)
    return (
      <div
        className={`invoice-flow-shell invoice-detail-shell${
          darkMode ? " dark" : ""
        }`}
      >
        <DashboardNavigation
          open={navOpen}
          onClose={() => setNavOpen(false)}
          activePath="/invoices"
          organisation={organisation}
          role={loginDetails?.roleName || "Owner"}
        />
        <div className="invoice-flow-main">
          <AppHeader
            onOpenNav={() => setNavOpen(true)}
            userName={currentUser}
          />
          <main className="invoice-detail-page">
            <div className="invoice-detail-orgbar">
              <DebitNoteResponsiveHeader
                organisation={organisation}
                role={loginDetails?.roleName || "Owner"}
              />
            </div>
            <button
              className="invoice-flow-back"
              type="button"
              onClick={() => navigate("/invoices")}
            >
              <LuArrowLeft />
              Back to Invoices
            </button>
            {loading ? (
              <PageSkeleton
                type="detail"
                variant="document"
                label="Loading invoice details…"
              />
            ) : (
              <>
                <header className="invoice-detail-header">
                  <div>
                    <h1>Invoice details</h1>
                    <p>
                      <span>{values.invoiceNumber}</span>
                      {values.contactName &&
                        (values.contactID ? (
                          <Link
                            to={`/contacts/${values.contactID}`}
                            className="invoice-detail-contact-link"
                          >
                            {values.contactName}
                          </Link>
                        ) : (
                          <span>{values.contactName}</span>
                        ))}
                      <b
                        className={`invoice-status status-${stateLabel
                          .toLowerCase()
                          .replace(/\s+/g, "-")}`}
                      >
                        {stateLabel}
                      </b>
                    </p>
                  </div>
                  <div className="invoice-editor-actions">
                    <button
                      type="button"
                      onClick={() =>
                        navigate(`/invoices/edit/${InvoiceID}?mode=preview`, {
                          state: {
                            previewReturn: {
                              path: `/invoices/view/${InvoiceID}`,
                              label: "Back to Invoice details",
                            },
                          },
                        })
                      }
                    >
                      <LuEye />
                      Preview
                    </button>
                    <button type="button" onClick={handleDirectDownload}>
                      <LuDownload />
                      Download PDF
                    </button>
                    {isDraft && (
                      <button
                        type="button"
                        onClick={() => navigate(`/invoices/edit/${InvoiceID}`)}
                      >
                        <LuPencil />
                        Edit draft
                      </button>
                    )}
                    {isDraft && (
                      <button
                        className="primary"
                        type="button"
                        onClick={() => handleEmailQuotation("send")}
                      >
                        <LuSend />
                        Send invoice
                      </button>
                    )}
                    {!isDraft && !isPaid && !isVoided && (
                      <button
                        className="primary"
                        type="button"
                        onClick={goToPayment}
                      >
                        <LuFileText />
                        Record payment
                      </button>
                    )}
                    {(isPaid || isVoided) && (
                      <button type="button" onClick={goToInvoiceHistory}>
                        <LuHistory />
                        View history
                      </button>
                    )}
                  </div>
                  <small>
                    {organisation} · All amounts in {currencyCode || "AUD"} ·
                    Created{" "}
                    {displayDate(values.createdAt || values.invoiceDate)}
                  </small>
                </header>
                {values.quotationID && (
                  <button
                    className="invoice-origin-link mobile-origin-link"
                    type="button"
                    onClick={() =>
                      navigate(`/quotations/view/${values.quotationID}`)
                    }
                  >
                    <LuFileText />
                    Source quote · {values.quotationNumber || "View quote"}
                  </button>
                )}
                <div className="invoice-source-banner">
                  <LuFileText />
                  <div>
                    <strong>
                      {isDraft
                        ? `Draft${
                            values.quotationNumber
                              ? ` created from ${values.quotationNumber}`
                              : " saved"
                          } · Not sent`
                        : values.quotationNumber
                        ? `Created from approved quote ${values.quotationNumber}`
                        : `Invoice ${stateLabel}`}
                    </strong>
                    <span>
                      {isDraft
                        ? "Review the draft and choose Send invoice when ready. No email has been sent and no payment has been recorded."
                        : values.quotationNumber
                        ? "Original quote content and approval are preserved in the source quotation."
                        : `Delivery and payment information for ${values.invoiceNumber}.`}
                    </span>
                  </div>
                  {values.quotationID && (
                    <button
                      className="invoice-origin-link desktop-origin-link"
                      type="button"
                      onClick={() =>
                        navigate(`/quotations/view/${values.quotationID}`)
                      }
                    >
                      <LuFileText />
                      Source quote · {values.quotationNumber || "View quote"}
                    </button>
                  )}
                </div>
                <div className="invoice-detail-grid">
                  <section className="invoice-flow-card invoice-content-card">
                    <h2>Invoice content</h2>
                    <p>
                      Review this saved invoice. Choose Edit draft only if
                      changes are needed.
                    </p>
                    <div className="invoice-detail-pairs">
                      <div>
                        <span>Prepared for</span>
                        <strong>
                          {values.contactID ? (
                            <Link
                              to={`/contacts/${values.contactID}`}
                              className="invoice-detail-contact-link"
                            >
                              {values.contactName || "—"}
                            </Link>
                          ) : (
                            values.contactName || "—"
                          )}
                        </strong>
                      </div>
                      <div>
                        <span>Invoice date</span>
                        <strong>{displayDate(values.invoiceDate)}</strong>
                      </div>
                    </div>
                    <hr />
                    <h2>Items &amp; pricing</h2>
                    <p>
                      {values.gstType === "No GST"
                        ? "No GST applies"
                        : "Unit prices and line totals include GST"}{" "}
                      · {currencyCode || "AUD"}
                    </p>
                    <div className="invoice-detail-items">
                      <div className="head">
                        <span>Description</span>
                        <span>Qty</span>
                        <span>Unit price</span>
                        <span>GST</span>
                        <span>Discount</span>
                        <span>Line total</span>
                      </div>
                      {itemRowValues.map((item, index) => (
                        <div className="row" key={item._id || index}>
                          <strong>
                            {item.itemName || item.description || "Item"}
                          </strong>
                          <span data-label="Quantity">
                            {item.itemQuantity || 0}
                          </span>
                          <span data-label="Unit price">
                            {money(item.itemPrice)}
                          </span>
                          <span data-label="GST">
                            {values.gstType === "No GST" ? 0 : item.gst || 0}%
                          </span>
                          <span data-label="Discount">
                            {item.discountType && item.discountType !== "None"
                              ? item.discountValue
                              : "None"}
                          </span>
                          <strong data-label="Line total">
                            {money(item.totalItemPrice)}
                          </strong>
                        </div>
                      ))}
                    </div>
                    <div className="invoice-content-summary">
                      <div>
                        {(
                          values.scopeNotes ||
                          values.scope ||
                          values.customerNotes ||
                          ""
                        ).trim() && (
                          <>
                            <span>Scope / customer notes</span>
                            <p>
                              {values.scopeNotes ||
                                values.scope ||
                                values.customerNotes}
                            </p>
                          </>
                        )}
                        {(values.terms || values.invoiceNotes || "").trim() && (
                          <>
                            <span>Invoice notes</span>
                            <p>{values.terms || values.invoiceNotes}</p>
                          </>
                        )}
                        <span>Payment terms</span>
                        <p>
                          {values.validUpto || values.dueUpto || "—"} · Due{" "}
                          {displayDate(values.dueDate)}
                        </p>
                        {String(values.paymentInstruction || "").trim() && (
                          <>
                            <span>Payment instructions</span>
                            <p>{values.paymentInstruction}</p>
                          </>
                        )}
                      </div>
                      <div>
                        <p>
                          <span>Total item discounts</span>
                          <strong>{money(values.totalDiscountAmount)}</strong>
                        </p>
                        <p>
                          <span>Subtotal excluding GST</span>
                          <strong>
                            {money(
                              Number(values.finalAmount || 0) -
                                Number(values.totalGSTAmount || 0)
                            )}
                          </strong>
                        </p>
                        <p>
                          <span>
                            {values.gstType === "No GST"
                              ? "No GST"
                              : "GST (included)"}
                          </span>
                          <strong>{money(values.totalGSTAmount)}</strong>
                        </p>
                        <hr />
                        <p>
                          <span>
                            {values.gstType === "No GST"
                              ? "Total"
                              : "Total including GST"}
                          </span>
                          <strong>{money(values.finalAmount)}</strong>
                        </p>
                      </div>
                    </div>
                    <hr />
                    <div className="invoice-attachments-line">
                      <div className="invoice-attachment-summary">
                        <strong>Attachments</strong>
                        <span>
                          {quoDocuments.length
                            ? `${quoDocuments.length} attachment(s)`
                            : "No attachments added"}
                        </span>
                      </div>
                      {quoDocuments.length > 0 && (
                        <div className="invoice-attachment-preview-actions">
                          {quoDocuments.map((attachment, index) => (
                            <button
                              key={
                                attachment._id || attachment.documentFileName
                              }
                              type="button"
                              className="invoice-attachment-view-button"
                              aria-label={`View attachment ${index + 1}`}
                              onClick={() => setPreviewAttachment(attachment)}
                            >
                              <LuEye aria-hidden="true" />
                            </button>
                          ))}
                        </div>
                      )}
                    </div>
                  </section>
                  <aside className="invoice-detail-aside">
                    {isDraft ? (
                      <section className="invoice-flow-card invoice-total-card">
                        <div>
                          <h2>Draft total</h2>
                          <LuFileText />
                        </div>
                        <strong>{money(values.finalAmount)}</strong>
                        <p>{currencyCode || "AUD"} · Draft · Not collectible</p>
                      </section>
                    ) : (
                      <section className="invoice-flow-card invoice-remaining-card">
                        <div className="invoice-remaining-summary">
                          <div className="invoice-remaining-heading">
                            <h2>Remaining balance</h2>
                            <LuFileText />
                          </div>
                          <div className="invoice-remaining-headline">
                            <strong>{money(outstanding)}</strong>
                            <p>
                              {currencyCode || "AUD"} · Due{" "}
                              {displayDate(values.dueDate)}
                            </p>
                          </div>
                        </div>
                        <div className="invoice-remaining-financials">
                          <b
                            className={`invoice-status status-${stateLabel
                              .toLowerCase()
                              .replace(/\s+/g, "-")}`}
                          >
                            {stateLabel}
                          </b>
                          <hr />
                          <div className="invoice-balance-breakdown">
                            <p>
                              <span>Invoice total</span>
                              <strong>{money(invoiceTotal)}</strong>
                            </p>
                            <p>
                              <span>Payments received</span>
                              <strong>{money(totalPaid)}</strong>
                            </p>
                            {debitTotal > 0 && (
                              <p>
                                <span>Issued debit notes</span>
                                <strong>{money(debitTotal)}</strong>
                              </p>
                            )}
                            <p>
                              <span>Applied credits</span>
                              <strong>{money(creditTotal)}</strong>
                            </p>
                          </div>
                          {!isPaid && !isVoided && (
                            <button
                              className="invoice-balance-payment-action"
                              type="button"
                              onClick={goToPayment}
                            >
                              <LuFileText /> Record payment
                            </button>
                          )}
                        </div>
                      </section>
                    )}
                    {isDraft ? (
                      <section className="invoice-flow-card invoice-settings-card">
                        <h2>Invoice settings</h2>
                        <span>Invoice date</span>
                        <strong>{displayDate(values.invoiceDate)}</strong>
                        <span>Planned due date</span>
                        <strong>{displayDate(values.dueDate)}</strong>
                        <span>Payment terms</span>
                        <strong>
                          {values.validUpto || values.dueUpto || "—"}
                        </strong>
                        <span>Invoice reference</span>
                        <strong>{values.purchaseOrderNumber || "—"}</strong>
                        <hr />
                        <h3>Delivery &amp; status</h3>
                        <p>
                          <b className="invoice-status">Draft</b> Not sent
                        </p>
                      </section>
                    ) : (
                      <section className="invoice-flow-card invoice-delivery-card">
                        <h2>Delivery</h2>
                        <p className="invoice-delivery-status">
                          <b>Sent</b>
                          <span>
                            {displayDate(
                              values.sentDate ||
                                values.updatedAt ||
                                values.invoiceDate
                            )}
                          </span>
                        </p>
                        <span>Recipient</span>
                        <strong>
                          {values.customerEmailAddress ||
                            values.emailAddress ||
                            "—"}
                        </strong>
                        <h2>Reminders</h2>
                        {!isPaid && !isVoided && (
                          <button
                            className="invoice-inline-action invoice-reminder-action"
                            type="button"
                            onClick={() => handleEmailQuotation("reminder")}
                          >
                            <LuSend /> Send reminder
                          </button>
                        )}
                      </section>
                    )}
                    {isDraft && (
                      <p className="invoice-draft-footnote">
                        Draft — not a receivable or money owed. Unsent drafts
                        are excluded from the dashboard's To receive balance.
                      </p>
                    )}
                  </aside>
                </div>
                {!isDraft && (
                  <div className="invoice-payment-credit-grid">
                    <section className="invoice-flow-card invoice-state-panel invoice-payment-history-card">
                      <div className="invoice-state-panel-heading">
                        <div>
                          <h2>Payment history</h2>
                          <p>
                            {isPaid
                              ? "This invoice is fully settled."
                              : "Payments recorded against this invoice."}
                          </p>
                        </div>
                      </div>
                      <div className="invoice-financial-grid">
                        <div>
                          <span>Invoice total</span>
                          <strong>{money(invoiceTotal)}</strong>
                        </div>
                        <div>
                          <span>Amount paid</span>
                          <strong>{money(totalPaid)}</strong>
                        </div>
                        <div>
                          <span>{isPaid ? "Outstanding" : "Amount due"}</span>
                          <strong>{money(isPaid ? 0 : outstanding)}</strong>
                        </div>
                      </div>
                      {paymentHistory.length ? (
                        <div className="invoice-payment-list">
                          {paymentHistory.map((payment, index) => (
                            <article key={payment._id || index}>
                              <strong>
                                {money(payment.paymentAmount || payment.amount)}
                              </strong>
                              <span>
                                {payment.paymentMethod ||
                                  payment.paymentType ||
                                  "Payment"}
                              </span>
                              <small>
                                {displayDate(
                                  payment.paymentDate || payment.createdAt
                                )}
                                {payment.referenceNumber
                                  ? ` · ${payment.referenceNumber}`
                                  : ""}
                              </small>
                            </article>
                          ))}
                        </div>
                      ) : (
                        <div className="invoice-payment-empty">
                          {isPaid
                            ? "No payment entries were returned for this invoice."
                            : "No payments recorded yet."}
                        </div>
                      )}
                    </section>
                    <section className="invoice-flow-card invoice-state-panel invoice-credit-notes-card">
                      <h2>Related credit / debit notes</h2>
                      {adjustmentNotes.length ? (
                        <div className="invoice-payment-list invoice-credit-list">
                          {adjustmentNotes.map((note, index) => (
                              <article key={`${note.type}-${note.noteID || index}`}>
                                <div className="invoice-credit-note-details">
                                  <strong>{money(note.amount)}</strong>
                                  <span>
                                    {note.type === "credit"
                                      ? "Credit applied"
                                      : "Debit applied"}
                                  </span>
                                  <small>{displayDate(note.date)}</small>
                                </div>
                                {note.noteID && (
                                  <Link
                                    className="invoice-inline-action invoice-credit-note-link"
                                    to={`/${note.type}Note/view/${note.noteID}`}
                                  >
                                    View details
                                  </Link>
                                )}
                              </article>
                            ))}
                        </div>
                      ) : (
                        <>
                          <strong>No applied credit or debit notes</strong>
                          <p>
                            Applied adjustments to this invoice will appear
                            here.
                          </p>
                        </>
                      )}
                    </section>
                  </div>
                )}
                {!isDraft && (
                  <section className="invoice-flow-card invoice-state-panel invoice-secondary-actions">
                    <div>
                      <h2>Invoice actions</h2>
                      <p>Actions available for this invoice state.</p>
                    </div>
                    <div>
                      {!isPaid && !isVoided && (
                        <button
                          className="invoice-inline-action"
                          type="button"
                          onClick={handleEmailQuotation}
                        >
                          <LuSend />
                          Resend invoice
                        </button>
                      )}
                      <button
                        className="invoice-inline-action"
                        type="button"
                        onClick={goToInvoiceHistory}
                      >
                        <LuHistory />
                        View delivery history
                      </button>
                      <button
                        className="invoice-inline-action"
                        type="button"
                        onClick={goToInvoiceHistory}
                      >
                        <LuHistory />
                        View full history
                      </button>
                    </div>
                  </section>
                )}
                <section className="invoice-flow-card invoice-history-card invoice-history-card-live">
                  <div className="invoice-history-heading">
                    <div>
                      <h2>
                        <LuHistory />
                        Invoice history &amp; notes
                      </h2>
                      <p>
                        Recent recorded activity · Internal notes are only
                        visible to your team.
                      </p>
                    </div>
                    <button
                      type="button"
                      className="quotation-history-link-btn"
                      onClick={goToInvoiceHistory}
                    >
                      View full history
                    </button>
                  </div>
                  <div className="invoice-private-note">
                    <LuLock />
                    <div>
                      <strong>Only visible to your team</strong>
                      <span>
                        History and internal notes never appear on the customer
                        document or PDF.
                      </span>
                    </div>
                  </div>
                  <div className="invoice-history-content">
                    {invoiceActivityFeed}
                    {invoiceNoteComposer}
                  </div>
                </section>
              </>
            )}
          </main>
        </div>
        <LoadingModal
          loading={loading && !invoiceDetailsRedesignEnabled}
          type="detail"
        />
        <InvoiceAttachmentPreview
          attachment={previewAttachment}
          onClose={() => setPreviewAttachment(null)}
          quotationStyle
        />
        <RecordInvoicePaymentDialog
          open={paymentDialogOpen}
          onClose={() => setPaymentDialogOpen(false)}
          onRecorded={FetchPendingInvoiceForCustomer}
          invoice={{ ...values, _id: InvoiceID }}
          outstanding={outstanding}
          totalPaid={totalPaid}
          currency={currencyCode || "AUD"}
          dispatch={dispatch}
        />
        {open && (
          <SendInvoiceModal
            open={open}
            onClose={() => setOpen(false)}
            invoiceNumber={values.invoiceNumber}
            customerName={values.contactName || "Customer"}
            customerEmail={
              values.customerEmailAddress || values.emailAddress || ""
            }
            customerEmails={templateValues?.customerEmailAddress}
            invoiceDate={values.invoiceDate}
            dueDate={values.dueDate}
            currency={currencyCode || "AUD"}
            finalAmount={emailMode === "reminder" ? outstanding : values.finalAmount}
            organisation={organisation}
            invoiceStatus={invoiceStatus}
            templateData={templateValues}
            onSend={handleSend}
            onViewInvoice={() => {
              setOpen(false);
              FetchPendingInvoiceForCustomer();
            }}
            darkMode={darkMode}
            mode={emailMode}
          />
        )}
      </div>
    );
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div style={{ marginTop: "20px" }}>
        <Card color="primary" sx={{ pb: "10px" }}>
          <PageTitle screenName="View Invoice" />
          <Grid container px={2} mt={2} spacing={2}>
            {/* invoice Number */}
            <Grid item lg={3} xs={6}>
              <TextField
                type="text"
                label="Invoice Number"
                variant="outlined"
                disabled
                fullWidth
                value={values.invoiceNumber}
                inputProps={{
                  className: "custom-fieldtext",
                }}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            {/* contact Name Dropdown */}
            <Grid item lg={3} xs={6}>
              <TextField
                type="text"
                label="Customer"
                variant="outlined"
                disabled
                fullWidth
                value={values.contactName}
                inputProps={{
                  className: "custom-fieldtext",
                }}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            {/* Reference Number */}
            <Grid item lg={3} xs={6}>
              <TextField
                type="text"
                label="Reference Number "
                variant="outlined"
                placeholder="Optional"
                fullWidth
                value={values.purchaseOrderNumber}
                inputProps={{
                  className: "custom-fieldtext",
                  maxLength: 50,
                }}
                InputLabelProps={{ shrink: true }}
                disabled
              />
            </Grid>
            <Grid item lg={3} xs={6}>
              <TextField
                type="text"
                label="Invoice Date"
                variant="outlined"
                fullWidth
                value={values.invoiceDate}
                inputProps={{
                  className: "custom-fieldtext",
                }}
                InputLabelProps={{ shrink: true }}
                disabled
              />
            </Grid>

            {/* validUpto */}
            <Grid item lg={3} xs={6}>
              <TextField
                type="text"
                label="Due Upto"
                variant="outlined"
                fullWidth
                value={values.validUpto}
                inputProps={{
                  className: "custom-fieldtext",
                }}
                InputLabelProps={{ shrink: true }}
                disabled
              />
            </Grid>

            <Grid item lg={3} xs={6}>
              <TextField
                type="text"
                label="Due Date"
                variant="outlined"
                fullWidth
                value={values.dueDate}
                inputProps={{
                  className: "custom-fieldtext",
                }}
                InputLabelProps={{ shrink: true }}
                disabled
              />
            </Grid>
            <Grid item lg={3} xs={6}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Status</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  style={{ height: "35.11px" }}
                  disabled
                  label="Status"
                  value={values.invoiceStatus}
                >
                  <MenuItem value="Unpaid">Unpaid</MenuItem>
                  <MenuItem value="Partial Paid">Partial Paid</MenuItem>
                  <MenuItem value="Paid">Paid</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
          <CardContent>
            <DataTable
              theme={darkMode ? "solarized" : "light"}
              columns={columns}
              data={itemRowValues}
              customStyles={customStyles}
              fixedHeaderScrollHeight="210px"
              fixedHeader={true}
            />
          </CardContent>
          <Grid container px={2} pt={2} pb={2} spacing={2}>
            <Grid item lg={3} xs={12}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">GST Type</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  style={{ height: "35.11px" }}
                  label="GST Type"
                  value={values.gstType || "Inclusive"}
                  disabled
                >
                  <MenuItem value="Inclusive">Inclusive</MenuItem>
                  <MenuItem value="Exclusive">Exclusive</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item lg={3} xs={12}>
              <TextField
                type="text"
                label={`Total Amount(${currencyCode})`}
                variant="outlined"
                fullWidth
                inputProps={{
                  className: "custom-fieldtext",
                }}
                InputLabelProps={{ shrink: true }}
                disabled
                value={values.totalAmount}
              />
            </Grid>
            <Grid item lg={3} xs={12}>
              <TextField
                type="text"
                label={`Total Discount Amount(${currencyCode})`}
                variant="outlined"
                fullWidth
                inputProps={{
                  className: "custom-fieldtext",
                }}
                InputLabelProps={{ shrink: true }}
                disabled
                value={values.totalDiscountAmount}
              />
            </Grid>
            <Grid item lg={3} xs={12}>
              <TextField
                type="text"
                label={`Final Amount(${currencyCode})`}
                variant="outlined"
                fullWidth
                inputProps={{
                  className: "custom-fieldtext",
                }}
                InputLabelProps={{ shrink: true }}
                disabled
                value={values.finalAmount}
              />
            </Grid>

            <Grid item lg={12} xs={12}>
              <TextField
                type="text"
                label="Payment Instructions"
                variant="outlined"
                fullWidth
                value={values.paymentInstruction}
                disabled
              />
            </Grid>
          </Grid>

          {quoDocuments.length > 0 && (
            <CardContent>
              <DataTable
                theme={darkMode ? "solarized" : "light"}
                columns={documentColumns}
                data={quoDocuments}
                fixedHeaderScrollHeight="210px"
                fixedHeader={true}
                customStyles={customStyles}
              />
            </CardContent>
          )}
          <Stack
            spacing={2}
            mt={2}
            pb={3}
            direction="row"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "10px",
            }}
          >
            <Button
              variant="outlined"
              size="small"
              style={{
                fontSize: "0.75rem",
                display: "flex",
                alignItems: "center",
                border: "1px solid #1ed6c9",
                color: "#1ed6c9",
                borderRadius: "5px",
              }}
              onClick={() => {
                navigate("/invoices");
              }}
            >
              Close
            </Button>

            <Button
              variant="outlined"
              size="small"
              style={{
                fontSize: "0.75rem",
                display: "flex",
                alignItems: "center",
                border: "1px solid #1ed6c9",
                borderRadius: "5px",
                color: "#1ed6c9",
              }}
              onClick={handleDirectDownload}
            >
              <DownloadIcon sx={{ marginRight: "5px" }} /> Download PDF
            </Button>
            <Button
              variant="outlined"
              size="small"
              style={{
                fontSize: "0.75rem",
                display: "flex",
                alignItems: "center",
                border: "1px solid #1ed6c9",
                borderRadius: "5px",
                color: "#1ed6c9",
              }}
              onClick={handleEmailQuotation}
            >
              Send Email
            </Button>
          </Stack>
        </Card>

        <div>
          <Card style={{ marginTop: "20px" }}>
            <ActivityLog name="Invoice" />
          </Card>
        </div>

        {(retentionItemValues.length > 0 || paymentHistory.length > 0) && (
          <Card color="success" sx={{ mt: 2 }}>
            <Grid item px={2} pt={1} xs={12} md={4} lg={12}>
              <p
                style={{
                  fontSize: "14px",
                  fontWeight: "bold",
                  color: "#008000",
                }}
              >
                Invoice Payment Details
              </p>
            </Grid>

            <CardContent sx={{ mb: 2 }}>
              {paymentHistory.length > 0 && (
                <DataTable
                  theme={darkMode ? "solarized" : "light"}
                  columns={paymentColumns}
                  data={paymentHistory}
                  fixedHeaderScrollHeight="210px"
                  fixedHeader={true}
                  customStyles={customStyles}
                />
              )}
              {retentionItemValues.length > 0 && (
                <DataTable
                  theme={darkMode ? "solarized" : "light"}
                  columns={columnRetention}
                  data={retentionItemValues}
                  fixedHeaderScrollHeight="210px"
                  fixedHeader={true}
                  customStyles={customStyles}
                />
              )}
            </CardContent>
          </Card>
        )}
      </div>

      <Modal
        className="document-preview-overlay"
        open={viewDocumentInModal}
        onClose={() => setViewDocumentInModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{
          "& .MuiModal-root": {
            width: "100%",
            height: "100%",
          },
        }}
      >
        <Card sx={pdfStyle}>
          <Box>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              Invoice Document Viewer
            </Typography>
            <iframe
              title="Invoice Document Viewer"
              src={getDocumentFileURL}
              width="100%"
              height="650"
              frameborder="0"
              allowfullscreen={true}
            ></iframe>

            <Grid
              container
              id="modal-modal-description"
              sx={{ mt: 2, justifyContent: "center" }}
            >
              <MDButton
                color="warning"
                className="modalButton"
                onClick={() => {
                  setViewDocumentInModal(false);
                }}
              >
                Close
              </MDButton>
            </Grid>
          </Box>
        </Card>
      </Modal>

      <LoadingModal loading={loading} />

      {open && (
        <SendInvoiceModal
          open={open}
          onClose={() => setOpen(false)}
          invoiceNumber={values.invoiceNumber}
          customerName={values.contactName || "Customer"}
          customerEmail={
            values.customerEmailAddress || values.emailAddress || ""
          }
          customerEmails={templateValues?.customerEmailAddress}
          invoiceDate={values.invoiceDate}
          dueDate={values.dueDate}
          currency={currencyCode || "AUD"}
          finalAmount={values.finalAmount}
          organisation={organisation}
          invoiceStatus={invoiceStatus}
          templateData={templateValues}
          onSend={handleSend}
          onViewInvoice={() => {
            setOpen(false);
            FetchPendingInvoiceForCustomer();
          }}
          darkMode={darkMode}
          mode={isDraft ? "send" : "resend"}
        />
      )}
    </DashboardLayout>
  );
}

export default ViewInvoices;
